/**
 * Cookie utilities for platform tracking
 */

const COOKIE_NAME = "booking_platform"
const COOKIE_EXPIRY_DAYS = 30

export type Platform = "fb" | "tiktok" | null

/**
 * Set the booking platform cookie
 */
export function setBookingPlatform(platform: "fb" | "tiktok"): void {
  const expiryDate = new Date()
  expiryDate.setDate(expiryDate.getDate() + COOKIE_EXPIRY_DAYS)
  document.cookie = `${COOKIE_NAME}=${platform}; expires=${expiryDate.toUTCString()}; path=/; SameSite=Lax`
}

/**
 * Get the booking platform from cookie
 */
export function getBookingPlatform(): Platform {
  const cookies = document.cookie.split(";")
  for (const cookie of cookies) {
    const [name, value] = cookie.trim().split("=")
    if (name === COOKIE_NAME) {
      if (value === "fb" || value === "tiktok") {
        return value
      }
    }
  }
  return null
}

/**
 * Clear the booking platform cookie
 */
export function clearBookingPlatform(): void {
  document.cookie = `${COOKIE_NAME}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`
}
